import React from 'react';
import { physicalOwners } from '../RequestForms/utils';

interface Props {
  data: any;
  formik: any;
  disableFields: any;
}

const PhysicalOwnerDropdown = (props: Props) => {
  return (
    <div className='form-group form-inline'>
      <label className='col-sm-3'>Physical Owner</label>
      <select
        className='form-control col-sm-8'
        id='physicalOwner'
        name='physicalOwner'
        onChange={props.formik.handleChange}
        disabled={props.disableFields}
        value={props.formik.values.physicalOwner}
        defaultValue={props.data}>
        {physicalOwners.map((owner: any, index: number) => {
          return (
            <option key={index} value={owner.Code}>
              {owner.Description}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default PhysicalOwnerDropdown;
